import { authorizedApi } from './index';

export const depositApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createApplePayLink: builder.mutation({
      query: (params = { paymentAmount: 10 }) => ({
        url: '/deposit/apple-pay',
        method: 'POST',
        body: {
          paymentAmount: params.paymentAmount,
          ...(params.isWeb && { isWeb: true }),
        },
      }),
    }),
    startDeposit: builder.mutation({
      query: (params = { network: 'solana' }) => ({
        url: '/deposit/start',
        method: 'POST',
        body: { network: params.network },
      }),
    }),

    getDepositInfo: builder.query({
      query: (uuid) => ({
        url: `/deposit/${uuid}`,
        method: 'GET',
      }),
    }),

    getDepositHistory: builder.query({
      query: () => ({
        url: '/deposit',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useStartDepositMutation,
  useCreateApplePayLinkMutation,
  useGetDepositInfoQuery,
  useGetDepositHistoryQuery,
} = depositApi;
